export default [
  {
    path: '/reimbursement',
    name: 'reimbursement',
    component: () => import('@/views/reimbursement/Reimbursement.vue'),
    meta: {
      title: 'Reimbursement ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Reimbursement',
      pageTitle: 'Reimbursement',
      breadcrumb: [
        {
          text: 'Reimbursement',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reimbursement/add',
    name: 'add-reimbursement',
    component: () => import(
      '@/views/reimbursement/control-reimbursement/AddEditReimbursement.vue'
    ),
    meta: {
      title: 'Add product ',
      requiresAuth: true,
      action: 'create',
      resource: 'product',
      pageTitle: 'product',
      breadcrumb: [
        {
          text: 'product',
          to: '/product',
        },
        {
          text: 'Add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/reimbursement/edit/:id',
    name: 'edit-reimbursement',
    component: () => import(
      '@/views/reimbursement/control-reimbursement/AddEditReimbursement.vue'
    ),
    meta: {
      title: 'Edit reimbursement ',
      requiresAuth: true,
      pageTitle: 'reimbursement',
      breadcrumb: [
        {
          text: 'reimbursement',
          to: '/reimbursement',
        },
        {
          text: 'Edit',
          active: true,
        },
      ],
    },
  },
]
